var Vimeo = require("@vimeo/player");

var videoFullWithCard = function (options) {
  this.options = {
    $el: false,
  };

  $.extend(true, this.options, options);
};

videoFullWithCard.prototype.init = function () {
  var self = this;

  // init video player
  var playerIframe = this.options.$el.find("iframe")[0];

  if (!playerIframe) return;

  this.player = new Vimeo.default(playerIframe);

  this.options.$el
    .find(".embed-container .video-overlay")
    .on("click", function () {
      self.options.$el
        .find(".embed-container .video-overlay")
        .addClass("hidden");
      self.options.$el.find(".text-card-column").addClass("move-down");

      self.player.play();
    });
};

module.exports = videoFullWithCard;